const overrides = {
    "USGG10YR:Ind": "GT10:GOV",
    "USGG2YR:": "GT2:GOV",
} as any;

export default overrides;
